export const NumOneCircleIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20.5791" r="18.6667" stroke="url(#paint0_linear_971_23871)" strokeWidth="2.66667"/>
            <path d="M21.012 30.5791H18.096V16.6591L14.88 18.5911L13.44 16.0951L18.096 13.2991H21.012V30.5791Z"
                  fill="url(#paint1_linear_971_23871)"/>
            <defs>
                <linearGradient id="paint0_linear_971_23871" x1="22.7586" y1="-21.7738" x2="77.5901"
                                y2="63.8423"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint1_linear_971_23871" x1="18.8276" y1="-11.7444" x2="60.2496"
                                y2="13.2922"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};
